import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSystemAuth } from './SystemAuthContext';

/**
 * Gate for the console. The mirror of ProtectedRoute, against the console
 * session rather than the tenant one.
 *
 * Convenience, not security - exactly as the tenant guard says. Anyone can
 * edit the JavaScript in their own browser; what actually protects the
 * platform is systemAuthMiddleware refusing the request.
 */
export function SystemRoute() {
  const { isAuthenticated, isLoading } = useSystemAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 text-sm text-slate-500">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/system/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
